export class Prevision {
    Month1?: number;
    Month2?: number;
    Month3?: number;
    Volume!: number;

    static mapFromJSON(json: any) {

        let p = new Prevision();

        p.Month1 = json['month1'];
        p.Month2 = json['month2'];
        p.Month3 = json['month3'];
        p.Volume = json['volume'];
        
        return p;
    }
}